const makeColorsConfig = (values) => ({
  ...values,
  get variables() {
    return this.presets[this.currentPresetName];
  },
  set variables(value) {
    this.presets[this.currentPresetName] = value;
  }
});
export {
  makeColorsConfig as m
};
//# sourceMappingURL=make-config.js.map
